import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

console.log('BreatheToBecome: Starting app initialization...');

try {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error("Could not find root element to mount to");
  }

  console.log('BreatheToBecome: Root element found, creating React root...');
  const root = ReactDOM.createRoot(rootElement);

  console.log('BreatheToBecome: Rendering App...');
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  console.log('BreatheToBecome: App rendered successfully!');
} catch (error) {
  console.error('BreatheToBecome: Fatal error during initialization:', error);
  const rootElement = document.getElementById('root');
  if (rootElement) {
    rootElement.innerHTML = `<div style="padding: 20px; color: red; font-family: monospace;">
      <h1>App failed to load</h1>
      <pre>${error}</pre>
    </div>`;
  }
}
